 export const GET_CASE_YEAR_LOBBYMESSAGE = '[LOBBY MESSAGE][GET] Get case year';
 export const GET_LANGUAGE_LOBBYMESSAGE = '[LOBBY MESSAGE][GET] Get language';
 export const GET_COUNTRY_SERVICE_LIST = '[LOBBY MESSAGE][GET] Get Country and Service Type List';
 export const RESET_LOBBY_MESSAGE_LIST = '[LOBBY MESSAGE][reset] Reset Lobby List';
 export const GET_PRODUCT_TYPE = '[LOBBY MESSAGE][GET] Get Service Type List';
 export const GET_LOBBYMESSAGE_By_PRODUCTTYPE_AND_LANGUAGE = '[ GET LOBBY MESSAGE] by using PahseID and Language';

 
